import React from 'react';
import { FiCheck, FiExternalLink } from "react-icons/fi";

function FluorescenceGoodToKnow(props) {
    return (
        <div className="rn-about-area ptb--120 bg_color--3">
            <div className="container">
                <div className="row row--35">
                    <div className="col-lg-12">
                        <div className="content-width-limited">
                            <div className="section-title">
                                <h2 className="title">Dobro je vedeti</h2>
                            </div>
                            <div className="mt--30">
                                <p className="description"><strong>Število mest je omejeno – obvezna je predhodna rezervacija na razpisane termine na spletni strani <a href="https://ecofungi.si/paketi-dozivetja/" target="_blank" rel="noopener noreferrer" style={{color: 'var(--color-primary)', textDecoration: 'underline'}}>https://ecofungi.si/paketi-dozivetja/ <FiExternalLink style={{display: 'inline', verticalAlign: 'middle', marginLeft: '3px'}} /></a>.</strong></p>

                                <h4 className="mt--40 mb--20">Izvozni rov</h4>
                                <ul className="list-style--1">
                                    <li>
                                        <FiCheck />
                                        Obisk je primeren za vse, tudi za gibalno ovirane, ker rov nima naklona.
                                    </li>
                                    <li>
                                        <FiCheck />
                                        Ogled traja do ene ure.
                                    </li>
                                    <li>
                                        <FiCheck />
                                        Obiskovalec prejme zaščitno opremo – očala in čelado.
                                    </li>
                                </ul>

                                <h4 className="mt--40 mb--20">Glavni rov</h4>
                                <ul className="list-style--1">
                                    <li>
                                        <FiCheck />
                                        Ogled je dovoljen osebam od 10 let do 70 let, oziroma osebam z dobro gibalno sposobnostjo in fizično kondicijo.
                                    </li>
                                    <li>
                                        <FiCheck />
                                        Ogled traja do dveh ur.
                                    </li>
                                    <li>
                                        <FiCheck />
                                        Obiskovalec prejme zaščitno opremo – očala, čelado, kombinezon, škornje.
                                    </li>
                                </ul>

                                <h4 className="mt--40 mb--20">Splošno</h4>
                                <ul className="list-style--1">
                                    <li>
                                        <FiCheck />
                                        Najmanjša skupina za ogled so 4 osebe.
                                    </li>
                                    <li>
                                        <FiCheck />
                                        Priporočamo udobno obutev in obleko.
                                    </li>
                                    <li>
                                        <FiCheck />
                                        V rovu je stalna temperatura 10 °C in 100 % vlaga.
                                    </li>
                                </ul>
                            </div>

                            <div className="mt--40">
                                <a href="https://ecofungi.si/paketi-dozivetja/" target="_blank" rel="noopener noreferrer" className="btn-default size-md">Rezerviraj ogled</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default FluorescenceGoodToKnow;
